<template>
  <div id="app">
    <AppFrame />
  </div>
</template>

<script>
import AppFrame from "./components/AppFrame.vue";

export default {
  name: "App",
  components: {
    AppFrame
  }
};
</script>

<style lang="scss">
@use "src/styles/colors" as *;
@import "src/styles/setup";
@import "src/styles/content";
@import "src/styles/grid";

html {
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  width: 100vw;
  min-width: 100vw;
  max-width: 100vw;
  overflow: hidden;
  background: #222;
  font-family: sans-serif;
  transition: background 0.3s ease;

  &.scanning {
    background: transparent;
  }
}
body {
  padding: 0;
  margin: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
